import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';
import { ModuleGuard } from './../../permission.guard';
import { Role } from './../../_models/role';
import { Permission } from './../../_models/permission';


// IMPORT CLIENT MODULE COMPONENTS

import { MainClientComponent } from './main-client.component';
import { ClientsComponent } from '../clients.component';
import { SingleClientComponent } from '../single-client/single-client.component';
import { ClientDashboardComponent } from '../client-dashboard/client-dashboard.component';
import { EditClientModalComponent } from '../edit-client-modal/edit-client-modal.component';

const routes: Routes = [
  {
    path: '',
    component: MainClientComponent,
    children: [
      {
        path: 'list',
        component: ClientsComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Client, Role.Manager], permission: [Permission.Client] }
      },
      {
        path: 'view/:id',
        component: ClientDashboardComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'client/:id',
      //   component: ClientDashboardComponent
      // },
      {
        path: 'edit/:id',
        component: EditClientModalComponent
      },
      {
        path: '',
        component: MainClientComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainClientRoutingModule { }
